import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Tab, TabsMenu } from "../../../UI/TabsMenu";
import Teams from "./Teams";
import classes from './TeamsPage.module.css'
import * as PathRouter from '../../../../models/PathRoute';
import lastUpdateIcon from '../../../../assests/learning-tracking/teams/lastUpdateIcon.png'

const TabsEnum = {
    basicDivision: 0,
    lessonDivision: 1
}

const TeamsPage = ({ currentTab }) => {

    const { texts } = useSelector(state => state.translate);
    const contentRef = useRef();
    const navigate = useNavigate();
    const homeUrl = useSelector(state => state.application.homeUrl);
    const location = useLocation();

    const { id, guid } = useParams();
    const showTeamsPopup = location.state && location.state.showTeamsPopup;
    const [displayLastChange, setDisplayLastChange] = useState()

    useEffect(() => {
        if (contentRef.current && contentRef.current.setCurrentTab) {
            contentRef.current.setCurrentTab(currentTab);
        }
        setDisplayLastChange(false)
    }, [guid]);

    const handleTabClick = (index) => {
        if (index === TabsEnum.basicDivision) {
            navigate(`${homeUrl}/${PathRouter.LEARNING_TRACKING}/${id}/${PathRouter.TEAMS}/all`)
        } else if (index === TabsEnum.lessonDivision) {
            navigate(`${homeUrl}/${PathRouter.LEARNING_TRACKING}/${id}/${PathRouter.TEAMS}/${0}`)
        }
    };

    return <div className={classes.TeamsPage}>
        {displayLastChange && <div className={classes.LastUpdate}>
            <img src={lastUpdateIcon} alt='lastUpdateIcon' />
            <div>{texts.lastSavedNow}</div>
        </div>}
        <TabsMenu ref={contentRef} dropClass={classes.TabsMenu} scrollContentHeight={"calc(100% - 17px)"} contentHeight={"100%"} menuDropClass={classes.Menu} dropClassSelectedTab={classes.SelectedTab} onTabClick={handleTabClick} >
            <Tab name={texts.basicTeamsForAllLessons}>
               <Teams showTeamsPopup={showTeamsPopup} lessonMode={false} setDisplayLastChange={setDisplayLastChange} />
            </Tab>
            <Tab name={texts.changingTeamsByLesson}>
                <Teams lessonMode={true} setDisplayLastChange={setDisplayLastChange} />
            </Tab>
        </TabsMenu>

    </div>
}
export default TeamsPage;